import React, { Component } from 'react'
import * as timeago from 'timeago.js'
import { adminList } from "../helpers/auth"



import style from "./Message.module.css"
import Typography from '@material-ui/core/Typography'

export default class Message extends Component {
    constructor(props) {
        super(props)
        this.state = {
            timestampFormatted: timeago.format(this.props.timestamp),
            intervalObj: null

        }
    }

    componentDidMount() {
        this.setState({
            intervalObj: setInterval(() => {
                this.setState({
                    timestampFormatted: timeago.format(this.props.timestamp)
                })
            }, 5000)
        })
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalObj)
    }


    render() {
        const mainClass = adminList.includes(this.props.email.toLowerCase()) ? style.message + " " + style.admin : style.message
        return (
            <div className={mainClass}>
                <Typography variant="body1" color="initial" className={style.email}>
                    {this.props.email}
                </Typography>
                <Typography variant="body1" color="initial" className={style.content}>
                    {this.props.content}
                </Typography>
                <Typography variant="body2" color="initial" className={style.timestamp}>
                    {this.state.timestampFormatted}
                </Typography>
            </div>
        )
    }
}
